var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header pb-8 pt-4"},[_c('b-container',{attrs:{"fluid":""}},[_c('span',{staticClass:"mask bg-info"})])],1),_c('b-container',{staticClass:"mt--6",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"order-xl-1",attrs:{"md":"12"}},[_c('UserManagement')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }